/**
 * Uploads a file to Cloudinary.
 * @param {File} file - The file to upload.
 * @param {string} cloudName - Your Cloudinary cloud name.
 * @param {string} uploadPreset - Your Cloudinary upload preset.
 * @param {string} folder - The folder name (e.g., trip ID) to store the file in Cloudinary.
 * @returns {Promise<string>} - A promise that resolves with the secure URL of the uploaded file.
 */
export const uploadToCloudinary = async (file, cloudName, uploadPreset, folder) => {
  const url = `https://api.cloudinary.com/v1_1/${cloudName}/upload`;
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', uploadPreset);
  formData.append('folder', folder); // Add the folder parameter

  // Detect if the file is a PDF and set resource_type accordingly
  if (file && file.type === "application/pdf") {
    formData.append('resource_type', 'raw');
  }

  try {
    const response = await fetch(url, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Cloudinary upload failed: ${errorData.error.message}`);
    }

    const data = await response.json();
    return data.secure_url; // Return the secure URL
  } catch (error) {
    console.error("Error uploading to Cloudinary:", error);
    throw error; // Re-throw the error to be caught by the caller
  }
};
